import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/discounts'

export default defineStore('dashboard-discounts',
  storeModule.createStoreModule('dashboard-discounts', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
